import React, { Component } from 'react';
import {connect}                 from 'react-redux';
import {SetError}           from '../../../actions/authenticActions';
import { GetRanckingTurmasTop,GetRanckingTop }   from '../../../actions/talentosAction';


class feeds_big extends Component {

    constructor(props){

        super(props);

        this.state = {

            posicao1:{posicao:null,pontos:null,nome:null,status:null},
            posicao2:{posicao:null,pontos:null,nome:null,status:null},
            posicao3:{posicao:null,pontos:null,nome:null,status:null},
            posicao4:{posicao:null,pontos:null,nome:null,status:null},
            posicao5:{posicao:null,pontos:null,nome:null,status:null},

        }
    }


    componentWillMount() {
        this.props.GetRanckingTurmasTop(this.props.session.turma).then((response)=>{
            const data = response.payload.data;

            if (data) {
                this.setState({
                    posicao1:(data[0]?{posicao:data[0].posicao,pontos:data[0].total_pontos,nome:data[0].tur_nome,status:data[0].flag_turma}:{posicao:null,pontos:null,nome:null,status:null}),
                    posicao2:(data[1]?{posicao:data[1].posicao,pontos:data[1].total_pontos,nome:data[1].tur_nome,status:data[1].flag_turma}:{posicao:null,pontos:null,nome:null,status:null}),
                    posicao3:(data[2]?{posicao:data[2].posicao,pontos:data[2].total_pontos,nome:data[2].tur_nome,status:data[2].flag_turma}:{posicao:null,pontos:null,nome:null,status:null}),
                    posicao4:(data[3]?{posicao:data[3].posicao,pontos:data[3].total_pontos,nome:data[3].tur_nome,status:data[3].flag_turma}:{posicao:null,pontos:null,nome:null,status:null}),
                    posicao5:(data[4]?{posicao:data[4].posicao,pontos:data[4].total_pontos,nome:data[4].tur_nome,status:data[4].flag_turma}:{posicao:null,pontos:null,nome:null,status:null}),
                  });
                
            }
          
          }).catch((error) => {
            this.props.SetError(500);
         });
    }


    render() {

        const opa = {'opacity':'0'}
        return (
            <div className="feeds big">
                <div className="feeds-columns feeds-columns-center">
                    <div className="feeds-column">
                        <div className="feed feed-opacity-20"></div>
                        <div className={this.state.posicao2.status? 'feed basic active active-40': 'feed basic'}>
                            <div className="feed-header">{this.state.posicao2.nome}</div>
                            <div className="feed-body">
                                <div className="feed-body-text feed-body-text-big">{this.state.posicao2.pontos}</div>
                            </div>
                            {this.state.posicao2.pontos?   <div className="feed-label feed-label-bottom-left"><div className="feed-label-value">{this.state.posicao2.posicao}º</div></div>:""} 
                        </div>
                        <div className="feed feed-opacity-20"></div>
                    </div>
                    <div className="feeds-column">
                         <div className={this.state.posicao3.status? 'feed basic active active-40': 'feed basic'}>      
                             <div className="feed-header">{this.state.posicao3.nome}</div>
                            <div className="feed-body">
                                <div className="feed-body-text feed-body-text-big">{this.state.posicao3.pontos}</div>
                            </div>
                            {this.state.posicao3.pontos?  <div className="feed-label">
                                <div className="feed-label-value">
                                {this.state.posicao3.posicao}º
                                </div>
                            </div> : ""}
                        </div>
                        <div className="feed feed-opacity-20"></div>
                        <div className={this.state.posicao1.status? 'feed basic active active-40': 'feed basic'}>
                            <div className="feed-header">{this.state.posicao1.nome}</div>
                            <div className="feed-body">
                                <div className="feed-body-text feed-body-text-big">{this.state.posicao1.pontos}</div>
                            </div>
                            {this.state.posicao1.pontos ?  <div className="feed-label active">
                                <div className="feed-label-value">
                                  {this.state.posicao1.posicao}º
                                </div>
                            </div>
                            :""}
                        </div>
                    </div>
                    <div className="feeds-column">
                        <div className="feed feed-opacity-20" style={opa}></div>
                        <div className={this.state.posicao4.status? 'feed basic active active-40': 'feed basic'}>
                            <div className="feed-header">{this.state.posicao4.nome}</div>
                            <div className="feed-body">
                                <div className="feed-body-text feed-body-text-big">{this.state.posicao4.pontos}</div>
                            </div>
                            {this.state.posicao4.pontos ?  <div className="feed-label feed-label-top-right">
                                <div className="feed-label-value">
                                {this.state.posicao4.posicao}º
                                </div>
                            </div>:""}
                        </div>
                        <div className="feed feed-opacity-20"></div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {

    return {session: state.auth.session};
}

export default connect(mapStateToProps, {GetRanckingTurmasTop,GetRanckingTop,SetError})(feeds_big);



// WEBPACK FOOTER //
// ./src/components/aluno/home/feeds_big.js